<!-- <section class="container">
  <app-side-bar-menu></app-side-bar-menu>
  <div class="page">
      <app-top-bar-menu class="topBar"></app-top-bar-menu>

      <div class="component-content">
        <router-outlet></router-outlet>

      </div>
  </div>

</section> -->
<!--<p-toast></p-toast>-->

<section>
  <app-menu-topo [(isShowMenu)]="this.showMenu"></app-menu-topo>
  <app-menu-lateral [(open)]="this.showMenu"></app-menu-lateral>
  <div class="page">
    <router-outlet></router-outlet>
  </div>
</section>
<p-toast></p-toast>










<!-- <section class="grid-container">
<div id="menu-esquerda">
  <app-side-bar-menu></app-side-bar-menu>

</div>
<div class="right-part">
  <div class="menu-superior">
    <app-top-bar class="topBar"></app-top-bar>

  </div>
  <div class="conteudo">
    <router-outlet></router-outlet>

  </div>
</div>
</section> -->
